import React from 'react';
import { Link } from 'react-router-dom';
import { Bed, UtensilsCrossed, ArrowRight, Bath, Users, Home, Sparkles } from 'lucide-react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
interface PropertyCardProps {
  id: string;
  title: string;
  type: string;
  bedrooms: number;
  bathrooms?: number;
  sleeps: number;
  beds?: number;
  price: string;
  image: string;
  airbnbUrl?: string;
  featured?: boolean;
}
export function PropertyCard({
  id,
  title,
  type,
  bedrooms,
  bathrooms = 2,
  sleeps,
  beds = 3,
  price,
  image,
  airbnbUrl,
  featured = false
}: PropertyCardProps) {
  return <Card className="group h-full flex flex-col transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 border-2 border-emerald-100 hover:border-amber-300 bg-white overflow-hidden" data-id="element-104">
      <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-emerald-600 to-teal-600" data-id="element-105">
        {image ? <img src={image} alt={title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-106" /> : <div className="h-full w-full flex items-center justify-center" data-id="element-107">
            <Home className="h-24 w-24 text-white/30" data-id="element-108" />
          </div>}
        <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-109" />

        {featured && <div className="absolute top-4 left-4 bg-gradient-to-r from-amber-400 to-amber-500 text-emerald-900 text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider shadow-lg flex items-center gap-1" data-id="element-110">
            <Sparkles className="h-3 w-3" data-id="element-111" />
            Featured
          </div>}

        <div className="absolute bottom-4 left-4 right-4 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 space-y-2" data-id="element-112">
          {airbnbUrl && <a href={airbnbUrl} target="_blank" rel="noopener noreferrer" className="block" data-id="element-113">
              <Button className="w-full bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-emerald-900 border-none font-bold shadow-xl" data-id="element-114">
                <svg className="h-4 w-4 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-115">
                  <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10z" data-id="element-116" />
                  <path d="M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" data-id="element-117" />
                </svg>
                Book on Airbnb
              </Button>
            </a>}
          <Link to={`/property/${id}`} data-id="element-118">
            <Button className="w-full bg-white/95 text-emerald-700 hover:bg-white border-2 border-white font-bold" data-id="element-119">
              View Details <ArrowRight className="ml-2 h-4 w-4" data-id="element-120" />
            </Button>
          </Link>
        </div>
      </div>

      <div className="flex flex-col flex-grow p-6 bg-gradient-to-b from-white to-emerald-50/30" data-id="element-121">
        <div className="mb-4" data-id="element-122">
          <p className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-2" data-id="element-123">
            {type}
          </p>
          <h3 className="font-serif text-2xl font-bold text-emerald-900 group-hover:text-emerald-700 transition-colors" data-id="element-124">
            {title}
          </h3>
        </div>

        <div className="grid grid-cols-4 gap-3 py-4 border-t border-b border-emerald-100 mb-6" data-id="element-125">
          <div className="flex flex-col items-center text-center" data-id="element-126">
            <Bed className="h-5 w-5 text-emerald-600 mb-1" data-id="element-127" />
            <span className="text-xs text-emerald-700 font-medium" data-id="element-128">
              {beds} Beds
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-129">
            <Bath className="h-5 w-5 text-emerald-600 mb-1" data-id="element-130" />
            <span className="text-xs text-emerald-700 font-medium" data-id="element-131">
              {bathrooms} Bath
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-132">
            <Users className="h-5 w-5 text-emerald-600 mb-1" data-id="element-133" />
            <span className="text-xs text-emerald-700 font-medium" data-id="element-134">
              {sleeps} Guest
            </span>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-135">
            <UtensilsCrossed className="h-5 w-5 text-emerald-600 mb-1" data-id="element-136" />
            <span className="text-xs text-emerald-700 font-medium" data-id="element-137">
              Kitchen
            </span>
          </div>
        </div>

        <div className="mt-auto flex items-center justify-between" data-id="element-138">
          <div data-id="element-139">
            <span className="text-lg font-bold text-emerald-900" data-id="element-140">{price}</span>
            <span className="text-sm text-emerald-600" data-id="element-141"> / night</span>
          </div>
        </div>
      </div>
    </Card>;
}